import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Store from './store'
import vuetify from './plugins/vuetify'
import '@babel/polyfill'
import i18n from './i18n'
import * as VueGoogleMaps from 'vue2-google-maps'
import moment from './plugins/moment'

Vue.prototype.$time = moment

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_API_KEY,
    libraries: 'places',
    installComponents: true
  }
})

Vue.config.productionTip = false

const Application = new Vue({
  router,
  store: Store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')

Store.$app = Application
